export const iconFontAwesomeDesignEye = (
	<i className="fa-solid fa-eye"></i>
);
